// extracted by mini-css-extract-plugin
export default {"job-applications":"JobApplications_job-applications__gs5Qj"};